<div class="logo">
    <img class="logo-image" src="assets/images/png/logo_finastra.png">
    <div class="logo-text">Payments To Go</div>
</div>
